import { useQuery } from 'react-query'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert } from '../../../utils/alert'

export type Abastecimento = {
  cod: number
  cod_usuario: number
  cod_veiculo: number
  nome_posto: string
  cnpj: string
  endereco: string
  data: string
  hora: string
  tipo_combustivel: number
  qntd_litros: string
  valor_litro: string
  valor_total: string
  forma_pagamento: number
  forma_pagamento_nome: string
  cupom_fiscal: string
  odom_atual: string
  tanque_cheio: boolean
  usuario_nome: string
  veiculo_nome: string
  frota: string
  cupom_fiscal_url: string
  tipo_combustivel_nome: string
  /**`posto` quando o abastecimento foi feito em um posto, `propriedade` quando foi na propriedade */
  tipo_local?: 'posto' | 'propriedade'
  /**Código do fornecedor (posto) selecionado */
  cod_posto?: number
  cod_propriedade?: number
  propriedade_nome?: string
  /**Quem assume o custo do abastecimento */
  responsavel_custo?: 'empresa' | 'pessoal'
  pagamento_efetuado?: boolean
  necessario_reembolso?: boolean
  desconto_folha?: boolean
  tipo_uso_nome?: string
}

interface Data {
  itens: Abastecimento[]
  total: number
}

export const useGetAbastecimento = (pagination = 15, page = 1, nome?: string) => {
  const queryKey: any = [`/abastecimento`]

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Data, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/abastecimento?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente}&pagination=${pagination}&page=${page}&embed=arquivos&nome=${nome}&order=-data_abastecimento,-hora_abastecimento`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de abastecimento!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_abastecimento: data,
    carregando_abastecimento: isFetching,
    refetch_data_abastecimento: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

export const useGetAbastecimentoTotal = () => {
  /**Key própria: se repetir a key da listagem paginada as duas viram a mesma query,
   * compartilhando cache e requisição */
  const queryKey: any = [`/abastecimento`, 'total']

  const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Data, Error>(
    queryKey,
    async () => {
      return api
        .get(
          `/abastecimento?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente}&order=-data_abastecimento,-hora_abastecimento&pagination=-1`
        )
        .then((response): any => {
          return response.data
        })
        .catch((error) => {
          errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de abastecimento!')
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_abastecimento_total: data,
    carregando_abastecimento_total: isFetching,
    refetch_data_abastecimento_total: refetch,
    isFetched: isFetchedAfterMount,
    isError: isError,
  }
}

// export const verificarImagemIA = (comprovante, extensao) => {
//   const queryKey: any = ['/abastecimento/ocr-cupom']
//   const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Error>(
//     queryKey,
//     async () => {
//       return api
//         .get(
//           `/abastecimento?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente}`
//         )
//         .then((response): any => {
//           return response.data
//         })
//         .catch((error) => {
//           errorAlert(error?.response?.data?.error ?? 'Falha ao obter análise do cupom!')
//         })
//     },
//     {
//       enabled: false,
//       refetchOnWindowFocus: false,
//     }
//   )

//   return {
//     data_abastecimento_ai: data,
//     loading_abastecimento_ai: isFetching,
//     refetch_data_abastecimento_ai: refetch,
//     isFetched: isFetchedAfterMount,
//     isError: isError,
//   }
// }